import PropTypes from 'prop-types';
import styled from 'styled-components';


const Navigation = styled.div`
  padding: ${(props) => `${props.theme.spacing[2]} 0`};
  border-top: ${(props) => `1px solid ${props.theme.colors.shades[6]}`};
  text-align: center;
`;

const NavigationItem = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 2px 0 3px;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${(props) => (props.current
    ? props.theme.colors.shades[3]
    : props.theme.colors.shades[5]
  )};
`;

NavigationItem.displayName = 'NavigationItem';

const CarouselNavigation = ({
  numberOfNavigationItems, currentNavigationItemIndex, onNavigationItemClick
}) => {

  const navigationItems = [];

  for (let i = 0; i < numberOfNavigationItems; i++) {
    navigationItems.push(
      <NavigationItem
        key={i}
        current={currentNavigationItemIndex === i}
        onClick={
          () => {
            onNavigationItemClick(i);
          }
        }
      />
    );
  }

  return (
    <Navigation>
      {navigationItems}
    </Navigation>
  );
};

CarouselNavigation.propTypes = {
  numberOfNavigationItems: PropTypes.number.isRequired,
  onNavigationItemClick: PropTypes.func.isRequired,
  currentNavigationItemIndex: PropTypes.number
};

CarouselNavigation.defaultProps = {
  currentNavigationItemIndex: 0
};

export default CarouselNavigation;
